<script>
    import page from 'page'
    import Nav from '../components/Nav.svelte'
    import { Entry, Notebook } from '../controller.js'

	export let notebook_id;
    export let entry_id = null;

    let notebook = Notebook.load(notebook_id)
    let aliases;

    let entry = new Entry()
    if (entry_id !== null) {
        entry = notebook.entries[entry_id]
        aliases = entry.aliases
    }

    function save() {
        notebook.upsert_entry(entry)
        notebook.save()
        page(`/notebook/${notebook.id}/${entry.id}`)
    }
    function cancel() {
        if (!confirm("Leave without saving changes?")) {
            return
        }
        if (entry.id != null) {
            page(`/notebook/${notebook.id}/${entry.id}`)
        }
        else {
            page(`/notebook/${notebook.id}`)
        }
    }
</script>

<Nav notebook_id={notebook.id} />

<div id="form">
    <label for="name">Name</label>
    <input name="name" id="name" bind:value={entry.name}>

    <label for="aliases">Aliases</label>
    <input name="aliases" id="aliases" bind:value={aliases} on:change={() => entry.aliases = aliases.split(",")}>

    <label for="category">Category</label>
    <input name="category" id="category" bind:value={entry.category}>

    <label for="section">Section</label>
    <input name="section" id="section" bind:value={entry.section}>

    <label for="description">Description</label>
    <textarea name="description" id="description" bind:value={entry.description}></textarea>

    <div id="buttons">
        <button on:click={save}>Save</button>
        <button on:click={cancel}>Cancel</button>
    </div>
</div>


<style>
    #form {
        max-width: 1200px;
        text-align: center;
        margin: auto;
    }
    label {
        padding-top: 15px;
        padding-bottom: 5px;
    }
    textarea {
        width: 100%;
        height: 500px;
    }
</style>
